export type LyricLookupMatch = { id: number; trackName: string; artistName: string; duration: number; plainLyrics: string; syncedLyrics: string };
type Result = { matches: LyricLookupMatch[] };

export async function browserLyricLookup(query: string): Promise<Result> {
    // LRCLIB explicitly supports browser CORS. This uses the visitor's connection
    // when its shared Cloudflare egress is rate-limited, without account headers.
    const response = await fetch(`https://lrclib.net/api/search?q=${encodeURIComponent(query)}`, { credentials: "omit", signal: AbortSignal.timeout(10000) });
    if (!response.ok) throw new Error(response.status === 429 ? "musicLyricsBusy" : "musicLookupFailed");
    const reader = response.body?.getReader(); if (!reader) throw new Error("musicLookupFailed");
    const chunks: Uint8Array[] = []; let size = 0;
    while (true) { const { done, value } = await reader.read(); if (done) break; size += value.length; if (size > 2000000) { await reader.cancel(); throw new Error("musicLookupFailed"); } chunks.push(value); }
    const bytes = new Uint8Array(size); let offset = 0; for (const chunk of chunks) { bytes.set(chunk, offset); offset += chunk.length; }
    const data: unknown = JSON.parse(new TextDecoder().decode(bytes));
    const matches: LyricLookupMatch[] = [];
    for (const value of Array.isArray(data) ? data : []) {
        if (!value || typeof value.id !== "number" || (!value.plainLyrics && !value.syncedLyrics)) continue;
        const text = (v: unknown, max: number) => typeof v === "string" ? v.trim().slice(0, max) : "";
        matches.push({ id: value.id, trackName: text(value.trackName, 200), artistName: text(value.artistName, 120), duration: Number(value.duration) || 0, plainLyrics: text(value.plainLyrics, 60000), syncedLyrics: text(value.syncedLyrics, 80000) });
        if (matches.length === 12) break;
    }
    return { matches };
}
